export default "__VITE_ASSET__BTKuoVfJ__"